import { useEffect } from "react";

function ZendeskPage() {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=abbeb1ed-6c3d-4ee5-8239-dd2be80b97e8";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existing = document.getElementById("ze-snippet");
      if (existing) existing.remove();

      // Clean up the Zendesk widget iframe/launcher injected by the script
      const launcher = document.getElementById("launcher");
      if (launcher) launcher.remove();
    };
  }, []);

  return <div />;
}

export default ZendeskPage;
